import { createNodeDef } from "../../nodes.helpers";
import { DataFieldType } from "src/types/data-field.types";
import { randAmount } from "@ngneat/falso";

export const randAmountNodeDef = createNodeDef({
  type: "randAmount",
  displayName: "Amount",
  defaultName: "amount",
  fields: [
    { type: DataFieldType.TEXT, key: "symbol", label: "Symbol" },
    { type: DataFieldType.NUMBER, key: "min", label: "Min" },
    { type: DataFieldType.NUMBER, key: "max", label: "Max" },
    { type: DataFieldType.NUMBER, key: "fraction", label: "Fraction" },
  ],
  initialData: (): {
    min?: number;
    max?: number;
    fraction?: number;
    symbol: string;
  } => ({
    min: undefined,
    max: undefined,
    fraction: undefined,
    symbol: "",
  }),
  generate: ({ node }) => {
    const min = Number.isInteger(node.data.min) ? node.data.min : undefined;
    const max = Number.isInteger(node.data.max) ? node.data.max : undefined;
    const fraction = getValidFraction(node.data.fraction);

    return randAmount({
      min,
      max,
      fraction,
      symbol: node.data.symbol || undefined,
    });
  },
});

function getValidFraction(value: number | undefined): number | undefined {
  if (typeof value !== "number") return undefined;
  return Math.min(Math.max(0, value), 100);
}
